export default {
  'football': [
    {
      'key': 'total_minutes',
      'title': 'Total Minutes Played',
      'short_title': 'MP',
    },
    {
      'key': 'appearances',
      'title': 'Appearances',
      'short_title': 'M',
    },
    {
      'key': 'lineups',
      'title': 'Lineups',
      'short_title': 'L',
    },
    {
      'key': 'substitutes',
      'title': 'Substitutes In',
      'short_title': 'I',
    },
    {
      'key': 'benches',
      'title': 'Starts on the bench',
      'short_title': 'B',
    },
    {
      'key': 'goals',
      'title': 'Goals',
      'short_title': 'G',
    },
    {
      'key': 'assists',
      'title': 'Assists',
      'short_title': 'A',
    },
    {
      'key': 'fantasy_points',
      'title': 'Fantasy Points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'american_football': [
    {
      'key': 'fantasy_points',
      'title': 'Fantasy Points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'hockey': [
    {
      'key': 'appearances',
      'title': 'Appearances',
      'short_title': 'M',
    },
    {
      'key': 'minutes',
      'title': 'Average Minutes Played',
      'short_title': 'MP',
    },
    {
      'key': 'goals',
      'title': 'Goals',
      'short_title': 'G',
    },
    {
      'key': 'assists',
      'title': 'Assists',
      'short_title': 'A',
    },
    {
      'key': 'goals_and_assists',
      'title': 'Points',
      'short_title': 'P',
    },
    {
      'key': 'goals_and_assists_mean',
      'title': 'Points per match',
      'short_title': 'P/M',
      'to_fixed': true,
    },
    {
      'key': 'fantasy_points',
      'title': 'Fantasy Points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'basket': [
    {
      'key': 'minutes',
      'title': 'Average Minutes Played',
      'short_title': 'MP',
    },
    {
      'key': 'minutes_in_last_5',
      'title': 'Average Minutes Played in last 5 games',
      'short_title': 'MP5',
      'to_fixed': true,
    },
    {
      'key': 'fp_per_minute',
      'title': 'Average Fantasy Points per Minute',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'projected_fp',
      'title': 'Projected Fantasy Points',
      'short_title': 'xFP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'baseball': [
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points per game',
      'short_title': 'FPG',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'cc_ski': [
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'alpine': [
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'biathlon': [
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'cycling': [
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'handball': [
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
    {
      'key': 'goals',
      'title': 'Goals',
      'short_title': 'G',
    },
  ],
  'lol': [
    {
      'key': 'kills',
      'title': 'Kills',
      'short_title': 'K',
    },
    {
      'key': 'deaths',
      'title': 'Deaths',
      'short_title': 'D',
    },
    {
      'key': 'assists',
      'title': 'Assists',
      'short_title': 'A',
    },
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'dota2': [
    {
      'key': 'kills',
      'title': 'Kills',
      'short_title': 'K',
    },
    {
      'key': 'deaths',
      'title': 'Deaths',
      'short_title': 'D',
    },
    {
      'key': 'assists',
      'title': 'Assists',
      'short_title': 'A',
    },
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'csgo': [
    {
      'key': 'kills',
      'title': 'Kills',
      'short_title': 'K',
    },
    {
      'key': 'deaths',
      'title': 'Deaths',
      'short_title': 'D',
    },
    {
      'key': 'assists',
      'title': 'Assists',
      'short_title': 'A',
    },
    {
      'key': 'fantasy_points',
      'title': 'Fantasy points',
      'short_title': 'FP',
      'to_fixed': true,
    },
    {
      'key': 'form',
      'title': 'Form',
      'short_title': 'F',
      'to_fixed': true,
    },
  ],
  'golf': [
    {
      'key': 'proj_rank',
      'title': 'Rank',
      'short_title': '#',
    },
    {
      'key': 'proj_oddsToWin',
      'title': 'Odds To Win',
      'short_title': 'Odds',
      'to_fixed': true,
    },
    {
      'key': 'proj_salary',
      'title': 'Salary',
      'short_title': '$',
    },
    {
      'key': 'proj_fantasyPoints',
      'title': 'Fantasy Points',
      'short_title': 'FtP',
      'to_fixed': true,
    },
  ],
  'cricket': [
    {
      'key': 'proj_intelligentRank',
      'title': 'Intelligent Rank',
      'short_title': 'I.Rank',
    },
    {
      'key': 'proj_value',
      'title': 'Player Value',
      'short_title': 'Value',
      'to_fixed': true,
    },
    {
      'key': 'proj_intelligentScore',
      'title': 'Intelligent Score',
      'short_title': 'I.Score',
      'to_fixed': true,
    },
  ],
}
